import { useCallback } from 'react';
import { useSelector } from 'react-redux';

import { RootState } from '../types/graph';
import { checkCondition } from '../util/graph';
import { ViewableQuestion } from '../types/global';

export const useCheckCondition = () => {
  const graph = useSelector((state: RootState) => state.graph);
  const formulas = useSelector((state: RootState) => state.kb.formulas);

  const check = useCallback(
    (
      condition: string | undefined,
      excludeQuestionId?: ViewableQuestion['extId'],
    ) => checkCondition(graph, formulas, condition, excludeQuestionId),
    [graph, formulas],
  );
  return check;
};
